import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';
import { sha1 } from './SHA2';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { safeJsonParse } from './safeJsonParse';
const TokenKey = 'film';
const host = window.location.host;

/**
 * 查询Cookie
 * @param key 关键字
 * @param domain 域名,不填取默认当前host
 */
export function getCookie(key: string, domain: string = host) {
  const config = { path: '', domain: domain };
  // return Cookies.getItem(key, config);
  return Cookies.getItem&&Cookies.getItem(key);
}

/**
 * 写入Cookie
 * @param key 关键字
 * @param val 值
 * @param domain 域名,不填取默认当前host
 */
export function setCookie(key: string, val: any, domain: string = host) {
  const config = { path: '', domain: domain };
  // return Cookies.set(key, val, config);
  return Cookies.set(key, val);
}

/**
 * 移除Cookie
 * @param key 关键字
 * @param domain 域名,不填取默认当前host
 */
export function removeCookie(key: string, domain: string = host) {
  const config = { path: '', domain: domain };
  // return Cookies.remove(key, config);
  return Cookies.remove(key);
}

/**
 * 获取
 * @param key 关键字
 */
export function getLocalStorage(key: string) {
  try {
    return localStorage.getItem(TokenKey + '_' + key);
  } catch (error) {
    console.log('catch');
    return '';
  }
}

/**
 * 写入LocalStorage
 * @param key 关键字
 */
export function setLocalStorage(key: string, val: any) {
  return localStorage.setItem(TokenKey + '_' + key, val);
}

/**
 * 获取GetSessonStorage
 * @param key 关键字
 */
export function getSessonStorage(key: string) {
  return sessionStorage.getItem(TokenKey + '_' + key);
}

/**
 * 写入SetSessonStorage
 * @param key 关键字
 * @param val 值
 */
export function setSessonStorage(key: string, val: any) {
  return sessionStorage.setItem(TokenKey + '_' + key, val);
}

/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return '';
}
/**
 * 是否是统一商城 true代表是
 */
export function checkUnifyShop() {
  const _win: any = window;
  if (_win.dfWebUnifyShop === true) {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断工会头
 */
export function unionFlag() {
  let currentUnionValue;
  const union = getQueryString('union');
  const { hostname, pathname } = window.location;
  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  } else if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    let val = pathname.match(/union\/\w+/g);
    currentUnionValue = val && val.length > 0 ? val[0].split('/')[1] : '';
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping
    if (
      (process.env.environment === 'test' && /^(?:union)/.test(hostname)) ||
      /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(hostname)
    ) {
      currentUnionValue = hostname.split('.')[1];
    } else {
      currentUnionValue = '';
    }

    return currentUnionValue;
  }
}

/**
 *
 * @param {*} body 转换内容
 * @param {*} isLocation 是否是经纬度定位,true:经纬度定位,false: cityid定位
 */
export function getAddressReturn(body, isLocation) {
  let data = {};
  if (isLocation) {
    data = body ? body : {};
  } else {
    data = {
      provinceId: body.district && body.district.id,
      provinceName: body.district && body.district.name,
      name: body.city && body.city.name,
      cityName: body.city && body.city.name,
      cityId: body.city && body.city.id,
      regionId: body.region && body.region.id,
      regionName: body.region && body.region.name,
      streetId: body.streets && body.streets.length && body.streets[0].id,
      streetName: body.streets && body.streets.length && body.streets[0].name
    };
  }
  return data;
}

export function cleanArray(actual: any[]) {
  const newArray: any[] = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * 对象转字符串
 * @param json 对象
 */
export function convertParam(json) {
  if (!json) return '';
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return '';
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    }),
  ).join('&');
}

/**
 * 错误收集器
 * @param key 标记
 * @param errorMessage 错误信息
 */
export function errorLog(page, key, errorMessage) {
  try {
    if (process.env.envType === 'prd') {
      const error = {
        page: page,
        error: `error - [${key}]`,
        data: errorMessage,
        timelog: new Date().toJSON(),
        cookies: document.cookie,
        localStorage: localStorage,
        sessionStorage: sessionStorage
      };
      Sentry.withScope((scope) => {
        scope.setExtras(error);
        const eventId = Sentry.captureException(error);
      });
    }
  } catch (e) {
    console.log('error', e);
  }
}
export function checkIsInIframe(){
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function getBannerHeight() {
  if(Cookies.get('PC_IFRAME_H5_FLAG') == 'true' && checkIsInIframe()) {
    return null;
  }
  const width = window.screen.availWidth;
  const rat = 95 / 375;
  const height = rat * width;
  return height;
}

/**
 * 权益接口加密
*/
export function handlePara( param){
  const appid = '100060';
  const secretKey =  'XCwAjoB4';
  const apiParams = {
    appId: appid,
    msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
    timestamp: +new Date(),
    version: '1.0.1',
    body: JSON.stringify(param || {}),
    sign: ''
  };
  apiParams.sign = sha1(secretKey + apiParams.body + secretKey);
  return apiParams;
}

/**
 * 时间戳转换成年月日
 * @param inputTime  时间戳
 * @returns yyyy-MM-dd HH-mm-ss
 */
 export function formatDateTime(inputTime) {
  const date = new Date(inputTime);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? `0${m}` : m;
  let d = date.getDate();
  d = d < 10 ? `0${d}` : d;
  let h = date.getHours();
  h = h < 10 ? `0${h}` : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? `0${minute}` : minute;
  second = second < 10 ? `0${second}` : second;
  return `${y}-${m}-${d} ${h}:${minute}:${second}`;
}

/**
 * 获取频道name
 * @param { number } channelId  // 频道ID
 * @return { String }  频道name
 */
export function getChannelName(channelId) {
  let id = Number(channelId);
  switch (id) {
    case 1:
      return '电影';
      break;
    case 2:
      return '优选生活';
      break;
    case 3:
      return '生日汇';
      break;
    case 4:
      return '门票';
      break;
    case 5:
      return '演出';
      break;
    case 6:
      return '运动健身';
      break;
    case 7:
      return '400预定';
      break;
    case 8:
      return '节日礼包';
      break;
    case 9:
      return '特卖会';
      break;
    case 10:
      return '工会活动';
      break;
    case 16:
      return '京东优选';
      break;
    case 17:
      return '东福超市';
      break;
    case 18:
      return '图书';
      break;
    case 20:
      return '小米有品';
      break;
    case 22:
      return '网易严选';
      break;
    case 998:
      return '图书';
      break;
    case 999:
      return '京东优选';
      break;
    default:
      return '优选生活';
      break;
  }
}

/**
 * iosMobile
 */
export function iosMobile() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && !!u.match(/AppleWebKit.*Mobile.*/);
}

/**
 * AndroidMobile
 */
export function AndroidMobile() {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

export function getXcxGioName(code) {
  switch (code) {
    case 'lfmini':
      return 'h5-东福乐福小程序';
    // case 'bfdmini':
    // case 'gwmini':
    // case 'exchangemini':
    default:
      return 'h5-微信小程序';
  }
}

//防抖
export function debounce(fn, delay){
	let timer: any = null;
	return function (this: any, ...args: any[]) {
		clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(this, arguments);
		}, delay);
	};
}

//节流
export function throttle(fn, delay){
	let valid = true;
	return function(this: any, ...args: any[]) {
		if(valid) {
			setTimeout(() => {
				fn.apply(this, arguments);
				valid = true;
			}, delay);
			valid = false;
		}
	};
}



export function getLocation(): Promise<Location> {
  return new Promise((r, j) => {
    // todo: app修复bug后可以删除超时处理
    const timer = setTimeout(() => {
      console.error('获取定位超时(5秒)');
      j('timeout');
    }, 5000);
    try {
      console.log('第二步');
      DFWebUtilsTools.initAddressDF(true, (value: any) => {
        console.log('第三步');
        clearTimeout(timer);
        r(value);
      });
    } catch (err) {
      clearTimeout(timer);
      j(err);
    }
  });
}

export const commonGetCityId = () => {
  const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
  const cityId = localAddress && localAddress?.cityId ? localAddress?.cityId :
    (getSessonStorage('currentAddress') && JSON.parse(getSessonStorage('currentAddress')).cityId) ||
    getQueryString('city') ||
    145;
  return cityId;
};


// 转换函数
export function transformCities(cities = []) {
  return (
    cities?.map((city:any) => ({
      cityId: city.id,
      name: city.cityName,
      pinyin: city.pinyin, // 假设我们只关心第一个pinyin
      first: city.aleph
    })) || []
  );
}

export function judgeTodayPopup(id) {
  try {
    const KEY = 'MOVE-CURRENT-DAY-POPUP-' + id;
    const cacheDay = localStorage.getItem(KEY);
    const current = new Date().toJSON().split('T')[0];
    if(cacheDay) {
      if(cacheDay == current) {
        return false;
      } else {
        localStorage.setItem(KEY, current);
        return true;
      }
    } else {
      localStorage.setItem(KEY, current);
      return true;
    }
  } catch (error) {
    return false;
  }
}